import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument]) {
        ai: globalSet(handle: "ai", siteId: $siteId) {
            ... on ai_GlobalSet {
                agendaReady
                programPublished
                showSiteChatbot
                siteAgentId
                showUserFeatures
                showInlineCards
                agentSubtitle
                buttonBackgroundColorSite
                startingMessageSite
                initialMessages {
                    message
                }
                appAgentId
                startingMessageApp
                initialMessagesApp {
                    message
                }
            }
        }
    }
`
